import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserRole } from '../enums';

export const authGuard: CanActivateFn = (_, state) => {
    const auth   = inject(AuthService);
    const router = inject(Router);

    // provideAppInitializer resolves auth state (token refresh + full profile)
    // before the router activates any route, so this check is synchronous.
    if (!auth.isAuthenticated()) {
        router.navigate(['/splash'], { state: { skipAuth: true } });
        return false;
    }

    // After authentication: non-admin users with no permissions must request access first.
    const isPermissionRoute = state.url.startsWith('/permissions');
    if (!isPermissionRoute) {
        const user          = auth.currentUser();
        const hasPermissions = (user?.permissions?.length ?? 0) > 0;
        const isSystemAdmin  = auth.hasRole(UserRole.SystemAdmin);

        if (!hasPermissions && !isSystemAdmin) {
            return router.createUrlTree(['/permissions/request']);
        }
    }

    return true;
};
